export default [
  [ // row 1
    {
      Backquote: {
        en: { shift: '~', down: '`', caps: '`' },
        ru: { shift: 'Ё', down: 'ё', caps: 'Ё' },
      },
    },
    {
      Digit1: {
        en: { shift: '!', down: '1', caps: '1' },
        ru: { shift: '!', down: '1', caps: '1' },
      },
    },
    {
      Digit2: {
        en: { shift: '@', down: '2', caps: '2' },
        ru: { shift: '"', down: '2', caps: '2' },
      },
    },
    {
      Digit3: {
        en: { shift: '#', down: '3', caps: '3' },
        ru: { shift: '№', down: '3', caps: '3' },
      },
    },
    {
      Digit4: {
        en: { shift: '$', down: '4', caps: '4' },
        ru: { shift: ';', down: '4', caps: '4' },
      },
    },
    {
      Digit5: {
        en: { shift: '%', down: '5', caps: '5' },
        ru: { shift: '%', down: '5', caps: '5' },
      },
    },
    {
      Digit6: {
        en: { shift: '^', down: '6', caps: '6' },
        ru: { shift: ':', down: '6', caps: '6' },
      },
    },
    {
      Digit7: {
        en: { shift: '&', down: '7', caps: '7' },
        ru: { shift: '?', down: '7', caps: '7' },
      },
    },
    {
      Digit8: {
        en: { shift: '*', down: '8', caps: '8' },
        ru: { shift: '*', down: '8', caps: '8' },
      },
    },
    {
      Digit9: {
        en: { shift: '(', down: '9', caps: '9' },
        ru: { shift: '(', down: '9', caps: '9' },
      },
    },
    {
      Digit0: {
        en: { shift: ')', down: '0', caps: '0' },
        ru: { shift: ')', down: '0', caps: '0' },
      },
    },
    {
      Minus: {
        en: { shift: '_', down: '-', caps: '-' },
        ru: { shift: '_', down: '-', caps: '-' },
      },
    },
    {
      Equal: {
        en: { shift: '+', down: '=', caps: '=' },
        ru: { shift: '+', down: '=', caps: '=' },
      },
    },
    {
      Backspace: {
        en: { shift: 'Backspace', down: 'Backspace', caps: 'Backspace' },
        ru: { shift: 'Backspace', down: 'Backspace', caps: 'Backspace' },
      },
    },
  ],
  [ // row2
    {
      Tab: {
        en: { shift: 'Tab', down: 'Tab', caps: 'Tab' },
        ru: { shift: 'Tab', down: 'Tab', caps: 'Tab' },
      },
    },
    {
      KeyQ: {
        en: { shift: 'Q', down: 'q', caps: 'Q' },
        ru: { shift: 'Й', down: 'й', caps: 'Й' },
      },
    },
    {
      KeyW: {
        en: { shift: 'W', down: 'w', caps: 'W' },
        ru: { shift: 'Ц', down: 'ц', caps: 'Ц' },
      },
    },
    {
      KeyE: {
        en: { shift: 'E', down: 'e', caps: 'E' },
        ru: { shift: 'У', down: 'у', caps: 'У' },
      },
    },
    {
      KeyR: {
        en: { shift: 'R', down: 'r', caps: 'R' },
        ru: { shift: 'К', down: 'к', caps: 'К' },
      },
    },
    {
      KeyT: {
        en: { shift: 'T', down: 't', caps: 'T' },
        ru: { shift: 'Е', down: 'е', caps: 'Е' },
      },
    },
    {
      KeyY: {
        en: { shift: 'Y', down: 'y', caps: 'Y' },
        ru: { shift: 'Н', down: 'н', caps: 'Н' },
      },
    },
    {
      KeyU: {
        en: { shift: 'U', down: 'u', caps: 'U' },
        ru: { shift: 'Г', down: 'г', caps: 'Г' },
      },
    },
    {
      KeyI: {
        en: { shift: 'I', down: 'i', caps: 'I' },
        ru: { shift: 'Ш', down: 'ш', caps: 'Ш' },
      },
    },
    {
      KeyO: {
        en: { shift: 'O', down: 'o', caps: 'O' },
        ru: { shift: 'Щ', down: 'щ', caps: 'Щ' },
      },
    },
    {
      KeyP: {
        en: { shift: 'P', down: 'p', caps: 'P' },
        ru: { shift: 'З', down: 'з', caps: 'З' },
      },
    },
    {
      BracketLeft: {
        en: { shift: '{', down: '[', caps: '[' },
        ru: { shift: 'Х', down: 'х', caps: 'Х' },
      },
    },
    {
      BracketRight: {
        en: { shift: '}', down: ']', caps: ']' },
        ru: { shift: 'Ъ', down: 'ъ', caps: 'Ъ' },
      },
    },
    {
      Backslash: {
        en: { shift: '|', down: '\\', caps: '\\' },
        ru: { shift: '/', down: '\\', caps: '\\' },
      },
    },
    {
      Delete: {
        en: { shift: 'Del', down: 'Del', caps: 'Del' },
        ru: { shift: 'Del', down: 'Del', caps: 'Del' },
      },
    },

  ],
  [ // row3
    {
      CapsLock: {
        en: { shift: 'CapsLock', down: 'CapsLock', caps: 'CapsLock' },
        ru: { shift: 'CapsLock', down: 'CapsLock', caps: 'CapsLock' },
      },
    },
    {
      KeyA: {
        en: { shift: 'A', down: 'a', caps: 'A' },
        ru: { shift: 'Ф', down: 'ф', caps: 'Ф' },
      },
    },
    {
      KeyS: {
        en: { shift: 'S', down: 's', caps: 'S' },
        ru: { shift: 'Ы', down: 'ы', caps: 'Ы' },
      },
    },
    {
      KeyD: {
        en: { shift: 'D', down: 'd', caps: 'D' },
        ru: { shift: 'В', down: 'в', caps: 'В' },
      },
    },
    {
      KeyF: {
        en: { shift: 'F', down: 'f', caps: 'F' },
        ru: { shift: 'А', down: 'а', caps: 'А' },
      },
    },
    {
      KeyG: {
        en: { shift: 'G', down: 'g', caps: 'G' },
        ru: { shift: 'П', down: 'п', caps: 'П' },
      },
    },
    {
      KeyH: {
        en: { shift: 'H', down: 'h', caps: 'H' },
        ru: { shift: 'Р', down: 'р', caps: 'Р' },
      },
    },
    {
      KeyJ: {
        en: { shift: 'J', down: 'j', caps: 'J' },
        ru: { shift: 'О', down: 'о', caps: 'О' },
      },
    },
    {
      KeyK: {
        en: { shift: 'K', down: 'k', caps: 'K' },
        ru: { shift: 'Л', down: 'л', caps: 'Л' },
      },
    },
    {
      KeyL: {
        en: { shift: 'L', down: 'l', caps: 'L' },
        ru: { shift: 'Д', down: 'д', caps: 'Д' },
      },
    },
    {
      Semicolon: {
        en: { shift: ':', down: ';', caps: ';' },
        ru: { shift: 'Ж', down: 'ж', caps: 'Ж' },
      },
    },
    {
      Quote: {
        en: { shift: '"', down: "'", caps: "'" },
        ru: { shift: 'Э', down: 'э', caps: 'Э' },
      },
    },
    {
      Enter: {
        en: { shift: 'Enter', down: 'Enter', caps: 'Enter' },
        ru: { shift: 'Enter', down: 'Enter', caps: 'Enter' },
      },
    },
  ],
  [ // row4
    {
      ShiftLeft: {
        en: { shift: 'Shift', down: 'Shift', caps: 'Shift' },
        ru: { shift: 'Shift', down: 'Shift', caps: 'Shift' },
      },
    },
    {
      KeyZ: {
        en: { shift: 'Z', down: 'z', caps: 'Z' },
        ru: { shift: 'Я', down: 'я', caps: 'Я' },
      },
    },
    {
      KeyX: {
        en: { shift: 'X', down: 'x', caps: 'X' },
        ru: { shift: 'Ч', down: 'ч', caps: 'Ч' },
      },
    },
    {
      KeyC: {
        en: { shift: 'C', down: 'c', caps: 'C' },
        ru: { shift: 'С', down: 'с', caps: 'С' },
      },
    },
    {
      KeyV: {
        en: { shift: 'V', down: 'v', caps: 'V' },
        ru: { shift: 'М', down: 'м', caps: 'М' },
      },
    },
    {
      KeyB: {
        en: { shift: 'B', down: 'b', caps: 'B' },
        ru: { shift: 'И', down: 'и', caps: 'И' },
      },
    },
    {
      KeyN: {
        en: { shift: 'N', down: 'n', caps: 'N' },
        ru: { shift: 'Т', down: 'т', caps: 'Т' },
      },
    },
    {
      KeyM: {
        en: { shift: 'M', down: 'm', caps: 'M' },
        ru: { shift: 'Ь', down: 'ь', caps: 'Ь' },
      },
    },
    {
      Comma: {
        en: { shift: '<', down: ',', caps: ',' },
        ru: { shift: 'Б', down: 'б', caps: 'Б' },
      },
    },
    {
      Period: {
        en: { shift: '>', down: '.', caps: '.' },
        ru: { shift: 'Ю', down: 'ю', caps: 'Ю' },
      },
    },
    {
      Slash: {
        en: { shift: '?', down: '/', caps: '/' },
        ru: { shift: ',', down: '.', caps: '.' },
      },
    },
    {
      ArrowUp: {
        en: { shift: '↑', down: '↑', caps: '↑' },
        ru: { shift: '↑', down: '↑', caps: '↑' },
      },
    },
    {
      ShiftRight: {
        en: { shift: 'Shift', down: 'Shift', caps: 'Shift' },
        ru: { shift: 'Shift', down: 'Shift', caps: 'Shift' },
      },
    },
  ],
  [ // row5
    {
      ControlLeft: {
        en: { shift: 'Ctrl', down: 'Ctrl', caps: 'Ctrl' },
        ru: { shift: 'Ctrl', down: 'Ctrl', caps: 'Ctrl' },
      },
    },
    {
      MetaLeft: {
        en: { shift: 'Win', down: 'Win', caps: 'Win' },
        ru: { shift: 'Win', down: 'Win', caps: 'Win' },
      },
    },
    {
      AltLeft: {
        en: { shift: 'Alt', down: 'Alt', caps: 'Alt' },
        ru: { shift: 'Alt', down: 'Alt', caps: 'Alt' },
      },
    },
    {
      Space: {
        en: { shift: ' ', down: ' ', caps: ' ' },
        ru: { shift: ' ', down: ' ', caps: ' ' },
      },
    },
    {
      AltRight: {
        en: { shift: 'Alt', down: 'Alt', caps: 'Alt' },
        ru: { shift: 'Alt', down: 'Alt', caps: 'Alt' },
      },
    },
    {
      ArrowLeft: {
        en: { shift: '←', down: '←', caps: '←' },
        ru: { shift: '←', down: '←', caps: '←' },
      },
    },
    {
      ArrowDown: {
        en: { shift: '↓', down: '↓', caps: '↓' },
        ru: { shift: '↓', down: '↓', caps: '↓' },
      },
    },
    {
      ArrowRight: {
        en: { shift: '→', down: '→', caps: '→' },
        ru: { shift: '→', down: '→', caps: '→' },
      },
    },
    {
      ControlRight: {
        en: { shift: 'Ctrl', down: 'Ctrl', caps: 'Ctrl' },
        ru: { shift: 'Ctrl', down: 'Ctrl', caps: 'Ctrl' },
      },
    },
  ],

];
